exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "th[data-v-f64d09c0],\ntd[data-v-f64d09c0] {\n  font-size: 12px;\n}", ""]);

// exports
